module.exports = __webpack_public_path__ + "img/Pescaria.55b0710c.png";